//Chainformation.Ccm.Core.
export class LightWeightClass {
    Id: number;
    Name: string;
    IsSystemObject?: boolean;
    constructor(item?) {
        this.Id = item ? item.Id : 0;
        this.Name = item ? item.Name : '';
        this.IsSystemObject = item ? item.IsSystemObject : false;
    }
}
